<template>
  <div class="justify-center text-center py-7 mx-auto" style="width: 90vw">
    <Statbar/>
    <v-container fluid>
      <v-tabs>
        <v-tab>Medlemsliste</v-tab>
        <v-tab>Betalinger</v-tab>
        <v-tab>Kontingent</v-tab>
        <v-tab-item>
          <MedlemsListe/>
        </v-tab-item>
        <v-tab-item>
          <Betalinger/>
        </v-tab-item>
        <v-tab-item>
          <Kontingent/>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import MedlemsListe from '@/components/MedlemsListe.vue'
import Betalinger from '@/components/Betalinger.vue'
import Kontingent from '@/components/Kontingent.vue'
import Statbar from '@/components/Statbar.vue'

export default {
  name: 'Medlems-Liste',
  components: {
    MedlemsListe,
    Betalinger,
    Kontingent,
    Statbar
  }
}
</script>
